import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import Story from '../components/Story';
import Schedule from '../components/Schedule';
import RSVP from '../components/RSVP';
import Accommodations from '../components/Accommodations';
import { weddingConfig } from '../config/weddingConfig';

const WeddingPage = () => {
  const location = useLocation();
  const isScrollingRef = useRef(false);

  useEffect(() => {
    // Scroll to section based on route
    const scrollToSection = () => {
      const path = location.pathname;
      
      if (path === '/') {
        // Scroll to top for home
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      // Extract section ID from path (e.g., /story -> story)
      const sectionId = path.substring(1); // Remove leading slash
      
      if (sectionId) {
        isScrollingRef.current = true;
        setTimeout(() => {
          const element = document.getElementById(sectionId);
          if (element) {
            const headerOffset = 80;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
            
            // Reset flag after scroll completes
            setTimeout(() => {
              isScrollingRef.current = false;
            }, 1000);
          }
        }, 100);
      }
    };

    scrollToSection();
  }, [location]);

  // Scroll handler removed to prevent auto-snapping to sections when scrolling stops
  // URL updates only occur through explicit navigation (clicking links, etc.)

  return (
    <>
      <Hero config={weddingConfig} />
      {weddingConfig.content.accommodations.enabled && <Story config={weddingConfig} />}
      {weddingConfig.content.schedule.enabled && <Schedule config={weddingConfig} />}
      {weddingConfig.content.rsvp.enabled && <RSVP config={weddingConfig} />}
      {weddingConfig.content.accommodations.enabled && <Accommodations config={weddingConfig} />}
    </>
  );
};

export default WeddingPage;

